/**
 * MSML HEALTH Content Config
 *
 * All user-facing copy centralised here.
 * Change text, labels, and descriptions without touching components.
 */

export const APP = {
  name: 'MSML HEALTH',
  tagline: 'AI Output Quality Instrument',
  description: 'Evaluate, score, and optimize AI-generated text for human-impact quality.',
};

export const NAV = {
  workspace: 'Analyze',
  history:   'History',
  cases:     'Cases',
  reports:   'Reports',
  demo:      'Demo',
  settings:  'Settings',
  admin:     'Admin',
};

export const DIMENSIONS = {
  agency:               { label: 'Agency',               short: 'Agency',      description: 'Empowers user decision-making' },
  clarity:              { label: 'Clarity',              short: 'Clarity',     description: 'Clear and unambiguous communication' },
  emotional_regulation: { label: 'Emotional Regulation', short: 'Emotion',     description: 'Supports emotional wellbeing' },
  cognitive_load:       { label: 'Cognitive Load',       short: 'Load',        description: 'Minimizes mental effort required' },
  safety:               { label: 'Safety & Risk',        short: 'Safety',      description: 'Avoids potential harms' },
  dependency:           { label: 'Dependency Risk',      short: 'Dependency',  description: 'Fosters independence, not reliance' },
  actionability:        { label: 'Actionability',        short: 'Action',      description: 'Provides concrete next steps' },
};

export const DIMENSION_ORDER = [
  'agency', 'clarity', 'emotional_regulation',
  'cognitive_load', 'safety', 'dependency',
];

export const SCORE_BANDS = {
  excellent: { label: 'Excellent', range: '85–100' },
  good:      { label: 'Good',      range: '70–84' },
  acceptable:{ label: 'Acceptable', range: '50–69' },
  poor:      { label: 'Needs Improvement', range: '0–49' },
};

export const VERDICTS = {
  APPROVED:     { label: 'Approved',     description: 'Optimization preserves intent and is safe' },
  NEEDS_REVIEW: { label: 'Needs Review', description: 'Minor concerns detected — review recommended' },
  REJECTED:     { label: 'Rejected',     description: 'Optimization blocked due to safety or intent issues' },
};

export const FLAGS = {
  high_risk:       { label: 'High Risk',        description: 'Safety score below threshold' },
  high_dependency: { label: 'High Dependency',   description: 'Creates reliance on AI' },
  overload:        { label: 'Cognitive Overload', description: 'Too much information density' },
};

export const EMPTY_STATES = {
  workspace:  { title: 'No analysis yet',          body: 'Paste AI-generated text and tap Analyze to see the HQ score, dimension breakdown, and improvement opportunities.' },
  history:    { title: 'No persisted analyses yet', body: "Switch to 'Persisted' mode in the workspace to save analysis history." },
  cases:      { title: 'No sample cases loaded',   body: 'Sample cases are loaded automatically on first visit.' },
  reports:    { title: 'No analyses yet',           body: 'Run some analyses first to see reports and statistics.' },
  trace:      { title: 'No trace logs yet',         body: 'Trace logs appear after users run analyses.' },
  demo:       { title: 'No demo runs available',     body: 'Demo runs are seeded automatically when demo mode is enabled.' },
};

export const FORM_LABELS = {
  domain:      { label: 'Domain',      placeholder: 'Auto-detect' },
  audience:    { label: 'Audience',    placeholder: 'Auto-detect' },
  sensitivity: { label: 'Sensitivity', placeholder: 'Auto-detect' },
};

export const DOMAIN_OPTIONS = [
  { value: '',              label: 'Auto-detect' },
  { value: 'healthcare',    label: 'Healthcare' },
  { value: 'education',     label: 'Education' },
  { value: 'finance',       label: 'Finance' },
  { value: 'legal',         label: 'Legal' },
  { value: 'customer_service', label: 'Customer Service' },
  { value: 'mental_health', label: 'Mental Health' },
  { value: 'wellness',      label: 'Wellness' },
  { value: 'general',       label: 'General' },
];

export const AUDIENCE_OPTIONS = [
  { value: '',            label: 'Auto-detect' },
  { value: 'general',     label: 'General Public' },
  { value: 'professional',label: 'Professional' },
  { value: 'vulnerable',  label: 'Vulnerable' },
  { value: 'children',    label: 'Children' },
  { value: 'elderly',     label: 'Elderly' },
];

export const SENSITIVITY_OPTIONS = [
  { value: '',        label: 'Auto-detect' },
  { value: 'low',     label: 'Low' },
  { value: 'medium',  label: 'Medium' },
  { value: 'high',    label: 'High' },
  { value: 'critical',label: 'Critical' },
];

export const ACTIONS = {
  analyze:   'Analyze',
  optimize:  'Optimize',
  export:    'Export JSON',
  print:     'Print',
  delete:    'Delete',
  rollback:  'Rollback',
  activate:  'Activate',
  save:      'Save',
  cancel:    'Cancel',
  runCase:   'Run Case',
  retry:     'Retry',
};

export const ERROR_MESSAGES = {
  generic:       'Something went wrong. Please try again.',
  unauthorized:  'Please log in to continue.',
  notFound:      'The requested resource was not found.',
  scoreFailed:   'Signal extraction failed. Try simplifying the input.',
  optimizeFailed:'Optimization failed. Please try again.',
  judgeFailed:   'Judge evaluation could not complete.',
};
